import { Resource } from 'datx-jsonapi-react';

export class LectureYears extends Resource {
  public static type = 'library/lecture_years';
}
